<div class="custom-filter-area">

    <div class="filters-area">
        <span class="title-txt">Warning: This Calculation is Final</span>
        <span class="cls-btn" (click)="onCloseBtn()"><mat-icon>close</mat-icon></span>
    </div>
    <div style="display: flex;">
        <div style="display: flex; margin: 5px 10px 0px 0px;">
            <img style="width: 35px;height: 35px;" src="../../../../assets/images/warning.png">
        </div>
        
        <div>
            <span class="title-txt" style="text-align: center;font-weight: 500;">Once you Run Rate Updates, your selection will be locked in and cannot be edited.</span>
            <!-- <span class="title-txt">{{title}}</span> -->
            <!-- <p style="font-size: 14px;">{{message}}</p> -->
        </div>
       
    </div>

    <div class="right-area">
        <button class="white-red-btn" (click)="onCloseBtn()">Cancel</button>
        <button class="red-white-btn" (click)="runRateCalculation()">Run Rate Updates</button>
    </div>

</div>